import {
  DocumentNode, LazyQueryHookOptions, LazyQueryResultTuple, OperationVariables, TypedDocumentNode,
  useLazyQuery as useLazyApolloQuery,
} from '@apollo/client';

function useLazyQuery<TData = any, TVariables = OperationVariables>(
  query: DocumentNode | TypedDocumentNode<TData, TVariables>, options?: LazyQueryHookOptions<TData, TVariables>,
): LazyQueryResultTuple<TData, TVariables> {
  options = options || {};

  options.fetchPolicy = options.fetchPolicy || 'network-only';

  return useLazyApolloQuery<TData, TVariables>(query, options);
}

export default useLazyQuery;
